import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { message,Rate,Modal,Button,DatePicker   } from 'antd';
import { Bar,Doughnut } from 'react-chartjs-2';

const dateFormat = 'DD-MM-YYYY';

const disabledDate = (current) => {
		return current && current > moment().endOf('day');
	};

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			total_school: 0,
			total_school_1: 0,
			value: '',
			aToken: '',
			graph_data: [],
			staff_graph_data: [],
			new_date: '',
			tag: '',
		}
	}
	
	

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}else{
			var date = new Date().toLocaleString("en-US", {timeZone: "Asia/Kolkata"});
			const new_acad = (new Date().getFullYear())+'-'+ (new Date().getFullYear()+1);
			
			var storedArray = JSON.parse(localStorage.getItem("schoolData"))
			var permission = storedArray['data'][0]['permission'];
			var user_type = storedArray['data'][0]['type'];
			setTimeout(() => {
				this.setState({ 
					user_id : storedArray['data'][0]['user_id'],
					school_id : storedArray['data'][0]['school_id'],
					permission : permission,
					user_type : user_type,
					academic_year : new_acad,
				});
			}, 50);
		}
		var user_id = storedArray['data'][0]['user_id'];
		var school_id = storedArray['data'][0]['school_id'];
		var type = storedArray['data'][0]['type'];
		var app = {user_id : user_id,school_id:school_id,type:type}
		getData('auth/get_login_token',app).then((result) => {
			let responseJson = result;
			if(responseJson.data){
				if(result['status'] == 200){
					var aToken= result['data'];
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
				else{
					var aToken='null';
					localStorage.setItem("aToken",aToken);
					var main_link = 'https://erp.kidzonia.co.in/panel/admin';
					var dayplan_link = 'https://erp.kidzonia.co.in/panel/dayplan';
					this.setState({
						main_link: main_link,
						dayplan_link: dayplan_link,
						aToken:aToken
					});
				}
			}
		});
		setTimeout(() => {
			this.checkStudent();
			this.checkStaff();
		}, 500);
	}
	
	
	checkStudent(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'],total_school:'0' });
			var date = this.state.new_date;
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			var app = {date : date,school_id:school_id,user_id:user_id,tag:this.state.tag}
			getData('GraphApi/attendance_tracker',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							graph_data: result['data'],
							total_school: result['total_school'],
							new_date: result['new_date'],
							is_next: result['is_next'],
							student_in: result['student_in'],
							student_absent: result['student_absent'],
							student_leave: result['student_leave'],
							student_halfday: result['student_halfday'],
							student_count: result['student_count'],
						});
					}else{
						this.setState({
							graph_data: [],
							total_school: 0,
						});
					}
				}
			});
		}
    }
	
	checkStaff(){
  	    if(localStorage.getItem('schoolData')){
			var storedArray = JSON.parse(localStorage.getItem("schoolData"));
			this.setState({ user_id : storedArray['data'][0]['user_id'],total_school_1:'0' });
			var date = this.state.s_new_date;
			var school_id = storedArray['data'][0]['school_id'];
			var user_id = storedArray['data'][0]['user_id'];
			var app = {date : date,school_id:school_id,user_id:user_id,tag:this.state.s_tag}
			getData('GraphApi/staff_attendance_tracker',app).then((result) => {
				let responseJson = result;
				if(responseJson.data){
					if(result['status'] == 200){
						this.setState({
							staff_graph_data: result['data'],
							total_school_1: result['total_school'],
							s_new_date: result['new_date'],
							s_is_next: result['is_next'],
							staff_in: result['staff_in'],
							staff_absent: result['staff_absent'],
							staff_leave: result['staff_leave'],
							staff_halfday: result['staff_halfday'],
							staff_count: result['staff_count'],
						});
					}else{
						this.setState({
							graph_data: [],
							total_school: 0,
						});
					}
				}
			});
		}
    }
	
	DateChange(date, dateString) {
	    this.setState({ new_date: dateString,selectedDate: dateString });
	    setTimeout(() => {
			this.checkStudent();
		}, 50);
	}	
	
	getPreviousDate = () => {
		this.setState({tag:'pre'});
		setTimeout(() => {
			this.checkStudent();
		}, 50);
	}
	
	getNextDate = () => {
	this.setState({tag:'nxt'});
		setTimeout(() => {
			this.checkStudent();
		}, 50);
	}
	
	DateChange1(date, dateString) {
	    this.setState({ s_new_date: dateString,selectedDate: dateString });
	    setTimeout(() => {
			this.checkStaff();
		}, 50);
	}	
	
	getPreviousDate1 = () => {
		this.setState({s_tag:'pre'});
		setTimeout(() => {
			this.checkStaff();
		}, 50);
	}
	
	getNextDate1 = () => {
	this.setState({s_tag:'nxt'});
		setTimeout(() => {
			this.checkStaff();
		}, 50);
	}
	
	
  

	render()

	{
	const {aToken}=this.state;
	const graph_data = {
  labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4', 'Label 5', 'Label 6'],
  datasets: [
    {
      label: 'Sample Horizontal Bar Graph',
      data: [12, 19, 3, 5], // Fewer data points compared to the labels
      backgroundColor: 'rgba(75, 192, 192, 0.6)', // Customize the bar color
      borderColor: 'rgba(75, 192, 192, 1)', // Customize the border color
      borderWidth: 1,
    },
  ],
};
	const options = {
	  plugins: {
		datalabels: {
		  formatter: (value, ctx) => {
			let sum = 0;
			let dataArr = ctx.chart.data.datasets[0].data;
			dataArr.map((data) => {
			  sum += data;
			});
			let percentage = ((value * 100) / sum).toFixed(2) + '%';
			return percentage;
		  },
		  color: '#fff',
		},
	  },
	};
					
		return (
			<>
				
				
				
				<div class="row bred">
					<div class="col-md-12">
						<div class="card ">
							<div class="card-body ">
								<h4 class="page-title"> 
									<i class="mdi mdi-apple-keyboard-command title_icon"></i> Attendance Tracker
									<div class="breadcrumb-wrapper">
										<ol class="breadcrumb">
											<li class="breadcrumb-item">
												<a href={`${process.env.PUBLIC_URL}/`} class="router-link-active" target="_self">
												<img src="https://erp.kidzonia.co.in/panel/assets/icons/home.png" className="home-img"/>
												</a>
											</li>
											<li class="breadcrumb-item"> Attendance Tracker</li>
										</ol>
									</div>
								</h4>
							</div>
						</div>
					</div>
				</div>
				
				<div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 graph-d">
						<div class="row">
						<div class="col-md-6">
							<div class="student-fees-border">
								
								<div class="col-md-12 no-padd">
									<span class="title">Staff Attendance</span>
								</div>
								<div class="row p-1">
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Total No. of Teacher</b> : {this.state.staff_count}</label>
								</div>
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Teacher Present</b> : {this.state.staff_in}</label>
								</div>
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Teacher Absent</b> : {this.state.staff_absent}</label>
								</div>
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Teacher Leave</b> : {this.state.staff_leave}</label>
								</div>
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Teacher Halfday</b> : {this.state.staff_halfday}</label>
								</div>
								</div>
							</div>
							
						</div>
						<div class="col-md-6">
							<div class="student-fees-border">
								
								<div class="col-md-12 no-padd">
									<span class="title">Student Attendance</span>
								</div>
								<div class="row p-1">
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Total No. of Student</b> : {this.state.student_count}</label>
								</div>
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Student Present</b> : {this.state.student_in}</label>
								</div>
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Student Absent</b> : {this.state.student_absent}</label>
								</div>
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Student Leave</b> : {this.state.student_leave}</label>
								</div>
								<div class="col-md-6">
									<label  style={{marginBottom: '0px'}}><b>Student Halfday</b> : {this.state.student_halfday}</label>
								</div>
								
							</div>
							</div>
							
						</div>
						
						</div>
                     </div>
                  </div>
               </div>
				
				
                <div class="">
                  <div class="row">
                     <div class="col-lg-12 mb-3 graph-d">
						<div class="row">
						<div class="col-md-6">
							<div class="student-fees-border">
								<div class="row">
								<div class="col-md-7">
									<span class="title">Staff Attendance Tracker</span>
								</div>
								<div class="col-md-5">
									<div class="iq-card date_range form-group d-flex att-trac">
									<svg onClick={this.getPreviousDate1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" fill="rgba(70,70,70,1)"/></svg>
									
									{this.state.s_new_date !='' && (<>
									<DatePicker value={moment(this.state.s_new_date, dateFormat)} format={dateFormat} disabledDate={disabledDate} onChange={this.DateChange1.bind(this)} className="att-fil-date"/>
									</>)}
									
									{(() => {
										if (this.state.s_is_next == '1') {
											return (
												<svg onClick={this.getNextDate1} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" fill="rgba(70,70,70,1)"/></svg>
											)
										}
									})()}
								</div>
								</div>
								{this.state.total_school_1 > 0 ? (<>
								
									{(this.state.staff_in > 0 || this.state.staff_absent > 0 || this.state.staff_leave > 0 || this.state.staff_halfday > 0 ) ? (<>
										<div class="col-md-12">
											<Doughnut data={this.state.staff_graph_data} options={options} height={150}/>
										</div>	
									</>) :(<>
										<div class="col-md-12">
											<h5 class="center">Attendance Not Marked !! </h5>
										</div>
									 
									</>)}
								
								</>) :(<>
									<div class="col-md-12">
										<h5 class="center">Please Wait While Loading !! </h5>
									</div>
								 
								</>)}
								
							</div>
							</div>
							
						</div>
						<div class="col-md-6">
							<div class="student-fees-border">
								<div class="row">
								<div class="col-md-7">
									<span class="title">Student Attendance Tracker</span>
								</div>
								<div class="col-md-5">
									<div class="iq-card date_range form-group d-flex att-trac">
									<svg onClick={this.getPreviousDate} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M10.828 12l4.95 4.95-1.414 1.414L8 12l6.364-6.364 1.414 1.414z" fill="rgba(70,70,70,1)"/></svg>
									
									{this.state.new_date !='' && (<>
									<DatePicker value={moment(this.state.new_date, dateFormat)} format={dateFormat} disabledDate={disabledDate} onChange={this.DateChange.bind(this)} className="att-fil-date"/>
									</>)}
									
									{(() => {
										if (this.state.is_next == '1') {
											return (
												<svg onClick={this.getNextDate} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30"><path fill="none" d="M0 0h24v24H0z"/><path d="M13.172 12l-4.95-4.95 1.414-1.414L16 12l-6.364 6.364-1.414-1.414z" fill="rgba(70,70,70,1)"/></svg>
											)
										}
									})()}
								</div>
								</div>
								{this.state.total_school > 0 ? (<>
								
								
								{(this.state.student_in > 0 || this.state.student_absent > 0 || this.state.student_leave > 0 || this.state.student_halfday > 0 ) ? (<>
								
								<div class="col-md-12">
									<Doughnut data={this.state.graph_data} options={options} height={150}/>
								</div>	
								</>) :(<>
									<div class="col-md-12">
										<h5 class="center">Attendance Not Marked !! </h5>
									</div>
								 
								</>)}
								
								</>) :(<>
									<div class="col-md-12">
										<h5 class="center">Please Wait While Loading !! </h5>
									</div>
								 
								</>)}
								
							</div>
							</div>
							
						</div>
						
						</div>
                     </div>
                  </div>
               </div>
			   </>
		) 
	} 
}
export default Index;
